import type { IntlShape } from "@formatjs/intl";
import type { CategoryEnum } from "../generated-axios-client";

const categoryTranslationIdMap: Record<CategoryEnum, string> = {
  RESINS_AND_HARDENERS: "material_category_resins_and_hardeners",
  PUTTY: "material_category_putty",
  PAINTS: "material_category_paints",
  SEALANTS_AND_PRIMERS: "material_category_sealants_and_primers",
  TOWER_COATINGS: "material_category_tower_coatings",
  SPECIAL_WORKS: "material_category_special_works",
  OTHER_MATERIALS: "material_category_other_materials",
  FABRIC: "material_category_fabric",
  VORTEX_GENERATORS: "material_category_vortex_generators",
};

export const getMaterialCategoryLabel = (intl: IntlShape, category: CategoryEnum) =>
  intl.formatMessage({ id: categoryTranslationIdMap[category] });

export const getMaterialCategoryOptions = (intl: IntlShape) =>
  (Object.keys(categoryTranslationIdMap) as CategoryEnum[]).map((category) => ({
    label: getMaterialCategoryLabel(intl, category),
    value: category,
  }));
